import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);

  const showError = (errorConfig) => setError(errorConfig);
  const clearError = () => setError(null);

  return (
    <ErrorContext.Provider value={{ error, showError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useGlobalError = () => useContext(ErrorContext);

ErrorProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
